<template>
    <card class="spaced typo" v-if="loaded">

        <div class="pt-2" v-if="ctrl.rows.length || search">

            <h2 class="text-white mb-4">{{ $t('common.clients') }}</h2>

            <table-control :paging="ctrl.paging" :search="true" v-model="search"></table-control>

            <base-table :data="ctrl.rows" :columns="columns">

                <template slot="columns">
                    <th>{{ $t('common.name') }}</th>
                    <th>{{ $t('common.entity') }}</th>
                    <th>{{ $t('common.permissions') }}</th>
                    <th>{{ $t('common.accesses') }}</th>
                    <th></th>
                </template>

                <template slot-scope="{row}">
                    <td :class="cellClass(row)">
                        {{ row.name }}
                    </td>
                    <td :class="cellClass(row)">
                        {{ entities[row.entity_id] }}
                    </td>

                    <td v-if="row.admin">
                        <badge type="info" class="mr-1">
                            {{ $t('common.admin') }}
                        </badge>
                    </td>
                    <td v-else>
                        <span v-for="(permission, key) in permissions['xapi-extra'].permissions" :key="key">
                            <badge type="info"
                                class="mr-1"
                                v-if="row.permissions[key]">
                                {{ permission.name }}
                            </badge>
                        </span>
                        <span v-for="(permission, key) in permissions['cmi5'].permissions" :key="key">
                            <badge type="info"
                                class="mr-1"
                                v-if="row.permissions[key]">
                                {{ permission.name }}
                            </badge>
                        </span>
                        <span v-for="(permission, key) in permissions['xapi-scopes'].permissions" :key="key">
                            <badge type="default"
                                class="mr-1"
                                v-if="row.permissions[key]">
                                {{ permission.name }}
                            </badge>
                        </span>
                    </td>

                    <td :class="cellClass(row)">
                        <a href="#" @click.prevent.stop="navToAccesses(row)">
                            {{ row.accesses_count > 1 
                                ? row.accesses_count + ' ' + $t('common.accesses').toLowerCase()
                                : row.accesses_count + ' ' + $t('common.access').toLowerCase()
                            }}
                        </a>
                    </td>

                    <td class="td-actions text-right">

                        <base-button icon link size="md" type="warning" @click="ctrl.update(row.id)">
                            <i class="tim-icons icon-pencil"></i>
                        </base-button>

                        <base-button icon link size="md" type="danger" @click="ctrl.delete(row.id)">
                            <i class="tim-icons icon-simple-remove"></i>
                        </base-button>

                    </td>
                </template>

            </base-table>

            <table-pagination :paging="ctrl.paging"></table-pagination>
        </div>

        <p class="text-center py-3" v-else>{{ $t('clients.no-client') }}</p>
                
        <div class="text-center">
            <base-button type="primary" @click="ctrl.create()">
                {{ $t('clients.new') }}
            </base-button>
        </div>

        <portal to="modals">

            <modal class="no-footer" :title="$t('common.client')" v-model="ctrl.modals.edit" :loading="ctrl.form.loading">
                <client-form v-model="ctrl.form.data" :errors="ctrl.form.errors" :permissions="permissions" :entities="entities">
                </client-form>
            </modal>

            <modal-confirm v-model="ctrl.modals.confirmDelete">
                <p>{{ $t('clients.delete-confirm') }}</p>
            </modal-confirm>

        </portal>

    </card>
</template>

<script>
    import CrudController from '@trax/classes/CrudController'
    import ClientForm from './ClientForm'

    export default {

        components: {
            ClientForm
        },

        data() {
            return {
                loaded: false,
                ctrl: new CrudController({
                    endpoint: '/trax/api/front/clients',
                    mapData: this.mapData,
                    unmapData: this.unmapData,
                    paging: {
                        perPage: 10,
                        perPageOptions: [5, 10, 25, 50],
                        total: 0
                    },
                    query: {
                        sort: ['name'],
                        include: ['entities', 'permissions'],
                        accessors: ['accesses_count'],
                        filters: {
                            owner_id: this.$auth.owner.id,
                            visible: true
                        }
                    }
                }),
                search: '',
                columns: ['name', 'entity', 'permissions', 'accesses'],
                entities: {},
                permissions: {}
            }
        },

        created() {
            this.ctrl.init(this, 'ctrl').then(resp => {
                this.loaded = true
                this.entities = resp.data.included.entities
                this.permissions = resp.data.included.permissions
            })
        },

        watch: {
            search(val) {
                this.ctrl.filter({
                    name: {$text: val},
                    owner_id: this.$auth.owner.id,
                })
            }
        },

        methods: {
            
            mapData(client) {
                return {
                    id: client ? client.id : null,
                    name: client ? client.name : null,
                    entity_id: client ? client.entity_id : (this.$auth.user.entity_id ? this.$auth.user.entity_id : null),
                    permissions: client && !Array.isArray(client.permissions) ? client.permissions : {},
                    admin: client ? client.admin : false,
                    active: client ? client.active : true,
                    accesses_count: client ? client.accesses_count : [],
                    meta: {
                        authority: client && client.meta.authority !== undefined ? client.meta.authority : { name: null, homePage: null }
                    }
                }
            },

            unmapData(data) {
                let client = {...data}
                client.owner_id = this.$auth.owner.id
                return client
            },

            cellClass(row) {
                return row.active ? '' : 'disabled'
            },

            navToAccesses(row) {
                this.$router.push({ name: 'accesses', params: { id: row.id } })
            }
        }
    }
</script>

<style scoped>

    td.disabled {
        color: #777 !important;
    }

</style>
